import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Checkbox, Chip, Tooltip } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { ROUTE_STRING } from 'constants/RouteString';
import CancelIcon from '@mui/icons-material/Cancel';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import HandymanIcon from '@mui/icons-material/Handyman';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { StatusAppType } from 'constants/AppEnums';
import PropTypes from 'prop-types';

export const StatusApp = {
  [StatusAppType.IN_ACTIVE]: {
    label: 'Inactive',
    color: 'error',
    icon: <CancelIcon />,
  },
  [StatusAppType.ACTIVE]: {
    label: 'Active',
    color: 'info',
    icon: <RocketLaunchIcon />,
  },
  [StatusAppType.COMING_SOON]: {
    label: 'Coming Soon',
    color: 'warning',
    icon: <HourglassEmptyIcon />,
  },
  [StatusAppType.DRAFT]: {
    label: 'Draft',
    color: 'warning',
    icon: <HandymanIcon />,
  },
};

const Table = ({ data, isLoading }) => {
  const columns = [
    {
      field: 'IconBlobReference',
      headerName: 'Logo',
      width: 75,
      sortable: false,
      renderCell: (params) => (
        <Box
          component='img'
          sx={{
            maxHeight: 50,
            maxWidth: 50,
            p: 1,
          }}
          alt={params.row.name}
          src={params.value}
          onError={(e) => {
            e.target.src = '/assets/images/apps/app-empty-state.svg';
          }}
        />
      ),
    },
    {
      field: 'Name',
      headerName: 'Name',
      width: 300,
      sortable: false,
      renderCell: (params) => (
        <NavLink
          className='MuiDataGrid-cellContent'
          to={ROUTE_STRING.LIST_APP.DETAIL.replace(':appId', params.row.Id)}
          style={{ textDecoration: 'none' }}
        >
          {params.value}
        </NavLink>
      ),
    },
    {
      field: 'Status',
      headerName: 'Status',
      width: 200,
      sortable: false,
      renderCell: (params) => (
        <Chip
          label={StatusApp[params.value].label}
          color={StatusApp[params.value].color}
          icon={StatusApp[params.value].icon}
          size='small'
          sx={{ px: 3 }}
        />
      ),
    },
    {
      field: 'IsPrivate',
      headerName: 'Public',
      width: 75,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Checkbox defaultChecked={!params.value} disabled />
      ),
    },
    {
      field: 'ShortDescription',
      headerName: 'Short Description',
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <Box
            component={'span'}
            sx={{ width: '100%', display: 'block' }}
            className='MuiDataGrid-cellContent'
          >
            {params.value}
          </Box>
        </Tooltip>
      ),
    },
  ];

  const rows = data?.Items || [];

  return (
    <DataGrid
      hideFooter
      disableColumnSelector
      disableColumnMenu
      rows={rows}
      columns={columns}
      getRowId={(row) => row.Id}
      loading={isLoading}
    />
  );
};

export default React.memo(Table);

Table.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
};
